module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/logo.60f1a4b4a037ca52d8f45f76eb265124.svg";